import { ROUTES } from 'base/routes/routes'
import { observer } from 'mobx-react'
import PageWrapper from 'pages/Components/PageWrapper'
import React, { useEffect, useState } from 'react'
import CustomButton from "base/ui/components/Button";
import { Download } from 'base/ui/components/Icons';
import { useTranslation } from 'react-i18next';
import BoxContainer from 'base/ui/components/BoxContainer';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import CustomSelect from 'base/ui/components/CustomSelect';
import { Form, Input, InputNumber, message } from 'antd';
import { getDropdownCatalog } from 'pages/Common/dropdown';
import { CommonModel } from 'services/Main/common_services';
import { commonPresenter, commonStore, exchangeRewardsPresenter, exchangeRewardsStore } from 'stores/root_store';
import useDebounce from 'hooks/useDebounce';
import { useNavigate, useParams } from 'react-router-dom';
import { GiftDropdownModel } from 'services/Main/exchangeRewards_services';
import { cloneDeep } from 'lodash';

const arrGift = [
  { value: 'HTQD2', label: 'Phiếu quà tặng Malloca' },
  { value: 'HTQD1', label: 'Chiếu khấu trực tiếp' }
]

const rewardsPage = () => {
  return observer(() => {
    const { t } = useTranslation();
    const [formResult] = Form.useForm();
    const navigate = useNavigate();

    const { customerId, programId } = useParams();
    // STATE =================================================================================================
    // STATE =================================================================================================
    // STATE =================================================================================================
    const [loading, setLoading] = useState(false);
    // lưu / lưu và tiếp tục
    const [isContinue, setContinue] = useState(false);

    const layoutSpan = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 }
    }

    // danh sách đơn vị
    const [measurementUnit, setMeasurementUnit] = useState<CommonModel[]>([])
    const [programList, setProgramList] = useState<CommonModel[]>([])
    const [valueGift, setValueGift] = useState<GiftDropdownModel[] | undefined>([])


    const getListProgram = async (key?: string) => {
      await commonPresenter.getListProgram(commonStore, key)
      if (commonStore.commonRespone.isSuccess) {
        setProgramList(commonStore.commonRespone.data)
      }
    }
    const debounceListProgram = useDebounce(getListProgram, 500)

    const handleGetDetail = async (typeExchangeReward?: string) => {
      await exchangeRewardsPresenter.getDetailCustomerExchangeReward(exchangeRewardsStore, customerId!, programId!, typeExchangeReward!)
      if (exchangeRewardsStore.detailReward.isSuccess) {
        formResult.setFieldsValue(exchangeRewardsStore.detailReward.data)


        // Data dropdown giá trị quà tặng
        setValueGift(exchangeRewardsStore.detailReward.data?.gifts)
      }
    }

    useEffect(() => {
      getDropdownCatalog({ onSetDropdown: setMeasurementUnit, params: { catalogTypeCode: 'MeasurementUnit' } })
      debounceListProgram()
      handleGetDetail('HTQD1')
    }, [])

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: 'Quản lý đổi thưởng',
            to: ROUTES.EXCHANGE_REWARDS.MANAGE.LINK,
          },
          {
            text: 'Tra cứu',
            to: ROUTES.EXCHANGE_REWARDS.MANAGE.CREATE.LINK,
          },
          {
            text: 'Đổi thưởng',
          },
        ]}
        extras={
          <>
            <CustomButton
              loading={loading}
              onClick={(e) => {
                formResult.submit()
                setContinue(false);
              }}
              disabled={!exchangeRewardsStore.detailReward.data?.isAllowExchangeReward}
              type="default"
            // icon={<Download className="!fill-black" />}
            >
              Đổi thưởng
            </CustomButton>

          </>
        }
      >


        <BoxContainer>
          <SearchForm
            form={formResult}
            {...layoutSpan}
            layout="horizontal"
            labelAlign="right"
            onFinish={async (fieldsValue) => {
              setLoading(true);
              const dataSave = cloneDeep(fieldsValue)
              const result = await exchangeRewardsPresenter.updateExchangeReward({
                giftId: dataSave?.giftId,
                customerCode: dataSave?.customerCode
              })
              if (result.message) {
                message.success(result.message);
                navigate(ROUTES.EXCHANGE_REWARDS.MANAGE.CREATE.LINK);
              } else {
                message.error(result.message);
              }
              setLoading(false);
            }}
            initialValues={{
              GiftApply: 'HTQD1',
              unit: 'DVT1'
            }}
            className='!mt-8'
            column='col-2'>
            <SearchItem label="Tên chương trình" name={'programName'} >
              <CustomSelect
                options={programList.map((item) => ({
                  label: `${item.value}`,
                  value: item.key,
                }))}
                showSearch
                allowClear
                disabled
                onSearch={(value) => value ? debounceListProgram(value) : debounceListProgram()}
                onClear={() => debounceListProgram()}
                filterOption={false} />
            </SearchItem>
            <SearchItem label="Mã khách hàng" name={'customerCode'}>
              <Input disabled />
            </SearchItem>
            <SearchItem label="Tên khách hàng" name={'customerName'}>
              <Input disabled />
            </SearchItem>
            <SearchItem label="Số điện thoại" name={'phone'}>
              <Input disabled />
            </SearchItem>
            <SearchItem label="Tổng doanh số tích lũy" name={'totalRevenue'}>
              <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} disabled className='!w-full' />
            </SearchItem>
            <SearchItem label="DS tích lũy đã đổi quà" name={'usedRevenue'}>
              <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} disabled className='!w-full' />
            </SearchItem>
            <SearchItem label="DS tích lũy còn lại" name={'remainValue'}>
              <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} disabled className='!w-full' />
            </SearchItem>
            <SearchItem label="Quà tặng áp dụng" name={'GiftApply'}>
              <CustomSelect
                // disabled={!exchangeRewardsStore.detailReward.data?.isAllowExchangeReward}
                onChange={(value, option) => {
                  if (value === 'HTQD2') {
                    formResult.setFieldValue('unit', 'DVT2')
                    handleGetDetail('HTQD2')
                  } else if (value === 'HTQD1') {
                    formResult.setFieldValue('unit', 'DVT1')
                    handleGetDetail('HTQD1')
                  }
                }} options={arrGift} />
            </SearchItem>
            {/* Hạng thành viên */}
            <SearchItem rules={[{ required: true, message: 'Vui lòng chọn giá trị' }]} label="Hạng thành viên" name={'giftId'} >
              <CustomSelect
                disabled={!exchangeRewardsStore.detailReward.data?.isAllowExchangeReward}
                options={
                  valueGift?.map(item => {
                    return {
                      label: item.memberRank,
                      value: item.giftId
                    }
                  })
                }
                showSearch
                allowClear
              />
            </SearchItem>
            {/* đơn vị */}
            <SearchItem label="Đơn vị" name={'unit'} >
              <CustomSelect
                // disabled={!exchangeRewardsStore.detailReward.data?.isAllowExchangeReward}
                disabled={true}
                options={measurementUnit.map((item) => ({
                  label: `${item.value}`,
                  value: item.key,
                }))} />
            </SearchItem>
          </SearchForm>
        </BoxContainer>

      </PageWrapper >
    )
  })
}

export default rewardsPage